import { Box, Button, DialogContentText, Divider, IconButton, MenuItem, Select, SelectChangeEvent, Stack, TextField, Tooltip } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import { ITaskDetails, ITaskType } from '../../interface/IOrders_Tasks';
import { useSelector } from 'react-redux';
import { ITaskStatus } from '../../interface/ITask';
import { isValidInputTimeValue } from '@testing-library/user-event/dist/utils';
import '../../App.css'
import { AxiosInstance } from '../../api/apiInstance';
import { IUser } from '../../interface/IUser';
import CameraDialog from '../camera/CameraDialog';
import DialogEditRma from './DialogEditRma';
import ExtensionIcon from '@mui/icons-material/Extension';
import PlaceIcon from '@mui/icons-material/Place';
import ProductsItemHierarchyDialog from '../productItems/ProductsItemHierarchyDialog';
import { IproductHierarchy, IproductLocation } from '../../interface/IProducts';


function TaskEditDialog(props: any) {

    const [dialogTitle, setDialogTitle] = useState('Part Hierarchy');
    const [partDialogDataLocation, setPartDialogDataLocation] = useState<IproductLocation[]>([]);
    const [partDialogDataHierarchy, setPartDialogDataHierarchy] = useState<IproductHierarchy[]>([]);
    const [openLocatioDialog, setOpenLocatioDialog] = useState(false);
    const [openDialogAssembly, setOpenDialogAssembly] = useState(false);
    const imageNo = useRef(1);
    const [url, setUrl] = useState<string | null>(null);
    const [takePicture, setTakePicture] = useState(false);
    const taskStatus: ITaskStatus[] = useSelector((state: any) => state.taskStatus)
    const [barcode, setBarcode] = useState('');
    const [validateBarcode, setValidateBarcode] = useState(false);
    const userinfo: IUser = useSelector((state: any) => state.user)


    const GetPartHierarchyData = async (id: string) => {
        setDialogTitle('Part Hierarchy');
        setPartDialogDataHierarchy([]);

        try {
            await AxiosInstance({
                // url of the api endpoint (can be changed)
                url: "priorityProducts/findChildByParentPart/" + props.rowData.PartNumber,
                method: "GET",
            }).then((res) => {
                const data = res.data as IproductHierarchy[];
                setPartDialogDataHierarchy(data);

            });
        } catch (e) {

        }
    }
    const GetPartLocationData = async (id: string) => {
        setDialogTitle('Part Location');
        setPartDialogDataLocation([]);
        try {
            await AxiosInstance({
                // url of the api endpoint (can be changed)
                url: "priority-products-locations/findAllByProductName/" + props.rowData.PartNumber,
                method: "GET",
            }).then((res) => {
                const data = res.data as IproductLocation[];
                setPartDialogDataLocation(data);

            });
        } catch (e) {

        }
    }
    const handleCloseDialogAssembly = () => {
        setOpenDialogAssembly(false);
    }


    const handleCloseProductsLocationDialog = () => {
        setOpenLocatioDialog(false);
    };
    useEffect(() => {
        if (props.rowData.pictureTwo?.lengh === 0)
            imageNo.current = 2;
    }, []);
    async function _handleScanChange(e: any) {

        setBarcode(e.target.value);
    }
    async function _clearPicture() {

        const tmpEdit = { ...props.rowData } as ITaskDetails
        tmpEdit.pictureOne = '';
        tmpEdit.pictureTwo = '';
        setUrl('');
        imageNo.current = 1;
        props.setDialogEditSingleTask(tmpEdit);
    }

    useEffect(() => {
        if (url === null || url === undefined || url === '') return;
        const tmpEdit = { ...props.rowData } as ITaskDetails
        if (imageNo.current === 1) {
            tmpEdit.pictureOne = url;
            imageNo.current = 2;
        }
        else {
            tmpEdit.pictureTwo = url;
            imageNo.current = 1;
        }
        props.setDialogEditSingleTask(tmpEdit);
    }, [url]);

    // async function _handleScanAssemblyChange(e: any) {

    //     setBarcode(e.target.value);
    // }    


    async function onKeyPressAssembly(event: any) {
        if (event.keyCode === 13) {
            try {
                await AxiosInstance({
                    // url of the api endpoint (can be changed)
                    url: "priorityProducts/findBarcode/" + event.target.value,
                    method: "GET",
                }).then((res) => {
                    //const partName = res.data;
                    if (res.data?.PARTNAME !== undefined) {
                        if (props.rowData.PartNumber === res.data?.PARTNAME) {
                            setValidateBarcode(true);
                            setBarcode('');
                        }
                    }
                });
            } catch (e) {
                // handle error
                console.error(e);

            }

        }
    }
    async function onKeyPressBarcode(event: any) {
        if (event.keyCode === 13) {
            try {
                await AxiosInstance({
                    // url of the api endpoint (can be changed)
                    url: "priorityProducts/findBarcode/" + event.target.value,
                    method: "GET",
                }).then((res) => {
                    //const partName = res.data;
                    if (res.data?.PARTNAME !== undefined) {
                        setDialogEditSingleTask(props.rowData.id, res.data.PARTNAME, 'PartNumber')
                        setBarcode('');
                        const nextfield = document.querySelector(
                            `input[name=NoOfBoxes]`
                        );
                        //nextfield?.focus()
                    }
                });
            } catch (e) {
                // handle error
                console.error(e);

            }
        }
    }

    function setDialogEditSingleTask(id: string, value: any, key: string) {
        console.log('setDialogEditSingleTask', key, value);
        const tmpEdit = { ...props.rowData } as ITaskDetails
        if (key === 'taskStatus') {
            const tmptaskStatus = taskStatus.find((t) => { if (t.id === value) return true; return false; });
            tmpEdit.taskStatus = tmptaskStatus || { id: 1, status: 'New', color: 'yellow' } as ITaskStatus;
        }
        else if (key === 'NoOfItems' || key === 'NoOfBoxes' ||
            key === 'BIN' || key === 'BIN_1' || key === 'BIN_2' ||
            key === 'QTY' || key === 'QTY_1' || key === 'QTY_2' ||
            key === 'bulkQauntity'
        ) {

            if (isNaN(Number(value)) || Number(value) < 0) tmpEdit[key] = '0';
            else 
                {
                    if ( key === 'BIN' || key === 'BIN_1' || key === 'BIN_2')
                        tmpEdit[key] = String(value);
                    else
                    tmpEdit[key] = Number(value);

                }
            console.log('in if ', key, tmpEdit[key])
            let tot: number =
                (
                    (Number(tmpEdit.NoOfBoxes) * Number(tmpEdit.NoOfItems)) +
                    (Number(tmpEdit.QTY) * Number(tmpEdit.BIN) || 0) +
                    (Number(tmpEdit.QTY_1) * Number(tmpEdit.BIN_1 || 0)) +
                    (Number(tmpEdit.QTY_2) * Number(tmpEdit.BIN_2 || 0)) +
                    tmpEdit.bulkQauntity
                );
            tmpEdit.Total = tot;
            console.log('tot ', tot)

        }
        else {
            tmpEdit[key] = value;

        }

        props.setDialogEditSingleTask(tmpEdit);
    }

    return (
        <div>
            <ProductsItemHierarchyDialog
                selectedValueHierarchy={partDialogDataHierarchy}
                selectedValueLocation={partDialogDataLocation}
                open={openLocatioDialog}
                onClose={handleCloseProductsLocationDialog}
                dialogTitle={dialogTitle}
            />
            <Box sx={{ my: 2 }}>

                {takePicture ? <CameraDialog
                    openCam={takePicture}
                    setTakePicture={setTakePicture}
                    url={url}
                    setUrl={setUrl}
                /> : <></>}
                <DialogContentText style={{ 'color': 'black' }} variant="h6">Status</DialogContentText>
                <Select sx={{ width: '90%' }}
                    labelId="demo-simple-select-helper-label"
                    id='taskStatus'
                    name='taskStatus'
                    value={props.rowData.taskStatus?.id ?? `1`}
                    onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                >
                    {
                        taskStatus.map((item, pos) => {
                            return (
                                <MenuItem value={item.id}>
                                    {item.status}
                                </MenuItem>
                            )
                        })
                    }
                </Select>
            </Box>
            <Box sx={{ my: 2 }}>
                {/* <DialogContentText variant="h6">{props.rowData?.taskType?.role === 'Good received' ?
                 'Title (Po) '
                 : 
                 'Title'}
                 </DialogContentText> */}
                <TextField
                    //disabled={userinfo.userRoleName === "Administrator" ? false : true}
                    disabled
                    label={props.rowData?.taskType?.role === 'Good received' ? 'Title (Po) ' : 'Title'}
                    key='DataInfo'
                    id="DataInfo"
                    type="text"
                    fullWidth
                    variant="outlined"
                    name="DataInfo"
                    onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                    value={props.rowData.DataInfo} />
            </Box>
            {props.rowData?.taskType?.role === 'RMA' ?
                <DialogEditRma
                    _clearPicture={_clearPicture}
                    setDialogEditRmaTask={setDialogEditSingleTask}
                    setTakePicture={setTakePicture}
                    singleTaskEdit={props.rowData}
                    _handleScanChange={_handleScanChange}
                    onKeyPressBarcode={onKeyPressBarcode}
                    barcode={barcode}
                /> : <></>
            }

            {props.rowData?.taskType?.role === 'Assembly' ||
                props.rowData?.taskType?.role === 'Assembly Order' ?
                <Box sx={{ my: 2 }}>
                    {
                        props.rowData?.taskType?.role === 'Assembly Order' ?
                            <DialogContentText variant="h6">Order number : {props.rowData.orderName}</DialogContentText>
                            : <></>}
                    <Stack direction={'row'}>
                        <Tooltip title="Location">
                            <IconButton color="success"
                                //id={row.id}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    //
                                    GetPartLocationData(props.rowData.id);
                                    setOpenLocatioDialog(true);
                                }}>
                                <PlaceIcon style={{ color: 'blue' }} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Hierarchy">
                            <IconButton color="success"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    GetPartHierarchyData(props.rowData.id);
                                    setOpenLocatioDialog(true);
                                }}>
                                <ExtensionIcon style={{ color: '#7CB9E8' }} />
                            </IconButton>
                        </Tooltip>
                        <DialogContentText variant="h6">Part No: {props.rowData.PartNumber}</DialogContentText>
                    </Stack>
                    <DialogContentText variant="h6">Qauntity to assemble: {props.rowData.QTYtoassemble}</DialogContentText>
                    {
                        props.rowData.taskInfo ?
                            <DialogContentText color={'red'} variant="h6">Remarks: {props.rowData.taskInfo}</DialogContentText>
                            : <></>

                    }
                    {
                        props.rowData.cylinder ?
                            <DialogContentText color={'red'} variant="h6">Cylinder: {props.rowData.cylinder}</DialogContentText>
                            : <></>
                    }
                    {/* <DialogContentText variant="h6">Scan</DialogContentText> */}
                    <Box sx={{ my: 2 }}>
                        <TextField autoComplete='off' id="outlined-basic" variant="outlined"
                            value={barcode}
                            label="Scan"
                            autoFocus
                            onChange={_handleScanChange}
                            onKeyDown={onKeyPressAssembly}
                        />
                    </Box>
                    {/* <DialogContentText style={{ 'color': 'black' }} variant="h6">QTY assembled</DialogContentText> */}
                    <Box sx={{ my: 2 }}></Box>
                    <TextField
                        id="Total" // change field "QTYassembled"
                        label="QTY assembled"
                        disabled={validateBarcode ? false : true}
                        type="number"
                        fullWidth
                        variant="outlined"
                        name="Total"
                        onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                        value={props.rowData.Total} />  </Box> : <></>
            }

            {props.rowData?.taskType?.role === 'Inventory count - Poland' ||
                props.rowData?.taskType?.role === 'Inventory count - US' ?
                <>
                    <Stack direction="row" spacing={2} sx={{ my: 2 }}>
                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText variant="h6">Location</DialogContentText> */}
                            <TextField
                                label="Location"
                                // disabled={userinfo.userRoleName === "Administrator" ? false : true}
                                key='Location'
                                id="Location"
                                type="text"
                                fullWidth
                                variant="outlined"
                                name="Location"
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.Location} />
                        </Box>

                    </Stack>
                    <Stack direction="row" spacing={2} sx={{ my: 2 }}>

                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText variant="h6">Part Number</DialogContentText> */}
                            <TextField
                                label="Part Number"
                                key='PartNumber'
                                id="PartNumber"
                                type="text"
                                fullWidth
                                variant="outlined"
                                name="PartNumber"
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.PartNumber} />
                        </Box>
                        {/* <DialogContentText variant="h6">Scan</DialogContentText> */}
                        <TextField autoComplete='off' id="outlined-basic" variant="outlined" value={barcode}
                            label="Scan"
                            autoFocus
                            onChange={_handleScanChange}
                            onKeyDown={onKeyPressBarcode}
                        />
                    </Stack>

                    <Stack direction="row" spacing={2} sx={{ my: 2 }}>
                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText variant="h6">bulkQauntity</DialogContentText> */}
                            <TextField
                                label="bulk Qauntity"
                                id='bulkQauntity'
                                key='bulkQauntity'
                                type="number"
                                fullWidth
                                variant="outlined"
                                name='bulkQauntity'
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.bulkQauntity} />
                        </Box>
                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText color={'blue'} variant="h6">Total</DialogContentText> */}
                            <TextField
                                label="Total"
                                disabled
                                id='Total'
                                key='Total'
                                type="number"
                                fullWidth
                                variant="outlined"
                                name='Total'
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.Total} />
                        </Box>
                    </Stack>

                </>
                :
                <></>}
            {props.rowData?.taskType?.role === 'Inventory count' ?
                <>
                    <Stack direction="row" spacing={2} sx={{ my: 2 }}>
                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText variant="h6">Location</DialogContentText> */}
                            <TextField
                                label="Location"
                                //disabled={userinfo.userRoleName === "Administrator" ? false : true}
                                disabled
                                key='Location'
                                id="Location"
                                type="text"
                                fullWidth
                                variant="outlined"
                                name="Location"
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.Location} />
                        </Box>

                    </Stack>
                    <Stack direction="row" spacing={2} sx={{ my: 2 }}>

                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText variant="h6">Part Number</DialogContentText> */}
                            <TextField
                                label="Part Number"
                                key='PartNumber'
                                id="PartNumber"
                                type="text"
                                fullWidth
                                variant="outlined"
                                name="PartNumber"
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.PartNumber} />
                        </Box>
                        {/* <DialogContentText variant="h6">Scan</DialogContentText> */}
                        <TextField autoComplete='off' id="outlined-basic" variant="outlined" value={barcode}
                            label="Scan"
                            autoFocus
                            onChange={_handleScanChange}
                            onKeyDown={onKeyPressBarcode}
                        />
                    </Stack>

                    <Stack direction="row" spacing={2} sx={{ my: 2 }}   >
                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText variant="h6">No Of Boxes</DialogContentText> */}
                            <TextField
                                label="No Of Boxes"
                                key='NoOfBoxes'
                                id="NoOfBoxes"
                                type="number"
                                fullWidth
                                variant="outlined"
                                name="NoOfBoxes"
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.NoOfBoxes} />
                        </Box>
                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText variant="h6">No Of Items</DialogContentText> */}
                            <TextField
                                label="No Of Items"
                                id='NoOfItems'
                                key='NoOfItems'
                                type="number"
                                fullWidth
                                variant="outlined"
                                name='NoOfItems'
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.NoOfItems} />
                        </Box>

                        {/* </Stack>
                  
                    <Stack direction="row" spacing={2}> */}
                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText variant="h6">No Of Boxes </DialogContentText> */}
                            <TextField
                                label="No Of Boxes"
                                key='BIN'
                                id="BIN"
                                type="number"
                                fullWidth
                                variant="outlined"
                                name="BIN"
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.BIN} />
                        </Box>
                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText variant="h6">NoOfItems</DialogContentText> */}
                            <TextField
                                label="No Of Items"
                                id='QTY'
                                key='QTY'
                                type="number"
                                fullWidth
                                variant="outlined"
                                name='QTY'
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.QTY} />
                        </Box>
                    </Stack>
                    <Stack direction="row" spacing={2} sx={{ my: 2 }}>
                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText variant="h6">NoOfBoxes</DialogContentText> */}
                            <TextField
                                label="No Of Boxes"
                                id='BIN_1'
                                key='BIN_1'
                                type="number"
                                fullWidth
                                variant="outlined"
                                name='BIN_1'
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.BIN_1} />
                        </Box>
                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText variant="h6">NoOfItems</DialogContentText> */}
                            <TextField
                                label="No Of Items"
                                id='QTY_1'
                                key='QTY_1'
                                type="number"
                                fullWidth
                                variant="outlined"
                                name='QTY_1'
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.QTY_1} />
                        </Box>
                        {/* </Stack>
                    <Stack direction="row" spacing={2}> */}
                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText variant="h6">NoOfBoxes</DialogContentText> */}
                            <TextField
                                label="No Of Boxes"
                                id='BIN_2'
                                key='BIN_2'
                                type="number"
                                fullWidth
                                variant="outlined"
                                name='BIN_2'
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.BIN_2} />
                        </Box>
                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText variant="h6">NoOfItems</DialogContentText> */}
                            <TextField
                                label="No Of Items"
                                id='QTY_2'
                                key='QTY_2'
                                type="number"
                                fullWidth
                                variant="outlined"
                                name='QTY_2'
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.QTY_2} />
                        </Box>
                    </Stack>
                    <Stack direction="row" spacing={2} sx={{ my: 2 }}>
                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText variant="h6">bulkQauntity</DialogContentText> */}
                            <TextField
                                label="bulk Qauntity"
                                id='bulkQauntity'
                                key='bulkQauntity'
                                type="number"
                                fullWidth
                                variant="outlined"
                                name='bulkQauntity'
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.bulkQauntity} />
                        </Box>
                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText color={'blue'} variant="h6">Total</DialogContentText> */}
                            <TextField
                                label="Total"
                                disabled
                                id='Total'
                                key='Total'
                                type="number"
                                fullWidth
                                variant="outlined"
                                name='Total'
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.Total} />
                        </Box>
                    </Stack>

                </>
                :
                <></>}
            {props.rowData?.taskType?.role === 'Good received' ?
                <>
                    <Stack direction="row" spacing={2} sx={{ my: 2 }}>
                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText variant="h6">Location</DialogContentText> */}
                            <TextField
                                label="Location"
                                disabled={userinfo.userRoleName === "Administrator" ? false : true}
                                key='Location'
                                id="Location"
                                type="text"
                                fullWidth
                                variant="outlined"
                                name="Location"
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.Location} />
                        </Box>
                    </Stack>
                    <Stack direction="row" spacing={2} sx={{ my: 2 }}>

                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText variant="h6">Part Number</DialogContentText> */}
                            <TextField

                                label="Part Number"
                                key='PartNumber'
                                id="PartNumber"
                                type="text"
                                fullWidth
                                variant="outlined"
                                name="PartNumber"
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.PartNumber} />
                        </Box>
                        {/* <DialogContentText variant="h6">Scan</DialogContentText> */}
                        <TextField autoComplete='off' id="outlined-basic"
                            variant="outlined" value={barcode}
                            label="Scan"
                            autoFocus
                            onChange={_handleScanChange}
                            onKeyDown={onKeyPressBarcode}
                        />
                    </Stack>

                    <Stack direction="row" spacing={2} sx={{ my: 2 }} >
                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText variant="h6">No Of Boxes</DialogContentText> */}
                            <TextField
                                label="No Of Boxes"
                                key='NoOfBoxes'
                                id="NoOfBoxes"
                                type="number"
                                fullWidth
                                variant="outlined"
                                name="NoOfBoxes"
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.NoOfBoxes} />
                        </Box>
                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText variant="h6">No Of Items</DialogContentText> */}
                            <TextField
                                label="No Of Items"
                                id='NoOfItems'
                                key='NoOfItems'
                                type="number"
                                fullWidth
                                variant="outlined"
                                name='NoOfItems'
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.NoOfItems} />
                        </Box>

                        {/* </Stack>
                 
                   <Stack direction="row" spacing={2}> */}
                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText variant="h6">No Of Boxes </DialogContentText> */}
                            <TextField
                                label="No Of Boxes"
                                key='BIN'
                                id="BIN"
                                type="number"
                                fullWidth
                                variant="outlined"
                                name="BIN"
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.BIN} />
                        </Box>
                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText variant="h6">NoOfItems</DialogContentText> */}
                            <TextField
                                label="No Of Items"
                                id='QTY'
                                key='QTY'
                                type="number"
                                fullWidth
                                variant="outlined"
                                name='QTY'
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.QTY} />
                        </Box>
                    </Stack>
                    <Stack direction="row" spacing={2} sx={{ my: 2 }}>
                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText variant="h6">NoOfBoxes</DialogContentText> */}
                            <TextField
                                label="No Of Boxes"
                                id='BIN_1'
                                key='BIN_1'
                                type="number"
                                fullWidth
                                variant="outlined"
                                name='BIN_1'
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.BIN_1} />
                        </Box>
                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText variant="h6">NoOfItems</DialogContentText> */}
                            <TextField
                                label="No Of Items"
                                id='QTY_1'
                                key='QTY_1'
                                type="number"
                                fullWidth
                                variant="outlined"
                                name='QTY_1'
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.QTY_1} />
                        </Box>
                        {/* </Stack>
                   <Stack direction="row" spacing={2}> */}
                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText variant="h6">NoOfBoxes</DialogContentText> */}
                            <TextField
                                label="No Of Boxes"
                                id='BIN_2'
                                key='BIN_2'
                                type="number"
                                fullWidth
                                variant="outlined"
                                name='BIN_2'
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.BIN_2} />
                        </Box>
                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText variant="h6">NoOfItems</DialogContentText> */}
                            <TextField
                                label="No Of Items"
                                id='QTY_2'
                                key='QTY_2'
                                type="number"
                                fullWidth
                                variant="outlined"
                                name='QTY_2'
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.QTY_2} />
                        </Box>
                    </Stack>
                    <Stack direction="row" spacing={2} sx={{ my: 2 }}>
                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText variant="h6">bulkQauntity</DialogContentText> */}
                            <TextField
                                label="bulk Qauntity"
                                id='bulkQauntity'
                                key='bulkQauntity'
                                type="number"
                                fullWidth
                                variant="outlined"
                                name='bulkQauntity'
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.bulkQauntity} />
                        </Box>
                        <Box sx={{ my: 2 }}>
                            {/* <DialogContentText color={'blue'} variant="h6">Total</DialogContentText> */}
                            <TextField
                                label="Total"
                                disabled
                                id='Total'
                                key='Total'
                                type="number"
                                fullWidth
                                variant="outlined"
                                name='Total'
                                onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.Total} />
                        </Box>
                    </Stack>

                </>
                : <></>}
            {props.rowData?.taskType?.role === 'Warehouse changes' ?
                <>
                    <Box sx={{ my: 2 }}>
                        {/* <DialogContentText variant="h6">Details:</DialogContentText> */}
                        <TextField
                            label="Details"
                            disabled
                            multiline
                            maxRows={4}
                            key='taskInfo'
                            id="taskInfo"
                            type="text"
                            fullWidth
                            variant="outlined"
                            name="taskInfo"
                            onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                            value={props.rowData.taskInfo} />
                    </Box>
                </>
                : <></>}
            {props.rowData?.taskType?.role === 'Picking' ?
                <>
                    {/* <DialogContentText variant="h6">Part No: {props.rowData.PartNumber}</DialogContentText>
                        <DialogContentText variant="h6">Picking quantity: {props.rowData.QTYtoassemble}</DialogContentText> */}
                    {
                        props.rowData.cylinder ?
                            <DialogContentText color={'red'} variant="h6">Cylinder: {props.rowData.cylinder}</DialogContentText>
                            : <></>
                    }
                    <Stack direction={'row'}>
                        <Tooltip title="Location">
                            <IconButton color="success"
                                //id={row.id}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    //
                                    GetPartLocationData(props.rowData.id);
                                    setOpenLocatioDialog(true);
                                }}>
                                <PlaceIcon style={{ color: 'blue' }} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Hierarchy">
                            <IconButton color="success"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    GetPartHierarchyData(props.rowData.id);
                                    setOpenLocatioDialog(true);
                                }}>
                                <ExtensionIcon style={{ color: '#7CB9E8' }} />
                            </IconButton>
                        </Tooltip>
                        <Box sx={{ my: 2 }} >
                            {/* <DialogContentText variant="h6">Details:</DialogContentText> */}
                            <TextField
                                label="Part No"
                                disabled
                                key='PartNumber'
                                id="PartNumber"
                                type="text"
                                fullWidth
                                variant="outlined"
                                name="PartNumber"
                                //onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                                value={props.rowData.PartNumber} />
                        </Box>
                    </Stack>
                    <Box sx={{ my: 2 }} >
                        <TextField
                            label="Picking Qauntity"
                            disabled
                            key='QTYtoassemble'
                            id="QTYtoassemble"
                            type="text"
                            fullWidth
                            variant="outlined"
                            name="QTYtoassemble"
                            //onChange={event => setDialogEditSingleTask(props.rowData.id, event.target.value, event.target.name)}
                            value={props.rowData.QTYtoassemble} />
                    </Box>
                </>
                : <></>}

        </div>
    )
}

export default TaskEditDialog
